import styled, { css } from 'styled-components';
import { rgba } from 'polished';

export const ExistingItemSC = styled.div<{ backgroundColor: string; textColor: string }>`
  width: 100%;
  height: 100%;
  border-radius: 5px;
  background: transparent;
  box-sizing: border-box;
  transition: all 0.2s;

  .edit {
    position: absolute;
    top: -16px;
    right: -13px;
    padding: 0;
    margin: 0;

    /* display: none; */
    opacity: 0;
    scale: 0;
    visibility: hidden;
    transition: all 0.2s;
    border-radius: 50%;
    z-index: 1;
    border: none;
    background: none;
    outline: none;
    cursor: pointer;

    svg {
      border-radius: 50%;
      filter: drop-shadow(0 0 4px rgba(0, 0, 0, 0.08));
    }
  }

  &:hover {
    .edit {
      /* display: block; */
      visibility: visible;
      opacity: 1;
      scale: 1;
      transition: all 0.2s;
    }
  }

  .menu-open & {
    opacity: 0.5;
  }

  .content {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    border-radius: 5px;
    border: 1px solid transparent;
    background: transparent;
    transition: all 0.2s;

    .item {
      flex: 1;
      border-radius: 5px;
      padding: 2px 4px;
      font-style: normal;
      font-weight: normal;
      font-size: 11px;
      line-height: 14px;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;

      ${({ backgroundColor, textColor }) =>
        css`
          color: ${textColor};
          border: 1px dashed ${backgroundColor};
          background: ${rgba(backgroundColor, 0.2)};
        `}

      margin-bottom: 2px;

      &:first-child {
        margin-top: 0;
      }

      &:last-child {
        margin-bottom: 0;
      }
    }
  }
`;
